export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Final (2)_01.69d65a97.jpg";